import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { RateManagerService } from 'src/app/services/modules/instant-rate-manager/rate-manager.service';
import { AlertUtil } from 'src/app/shared/utils/alert-dialog.util';

@Component({
  selector: 'app-action-buttons',
  standalone: true,
  imports: [CommonModule, NgbPopoverModule],
  templateUrl: './action-buttons.component.html',
  styleUrl: './action-buttons.component.scss'
})
export class ActionButtonsComponent implements ICellRendererAngularComp {
  rateMangerService = inject(RateManagerService);

  params: any;

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }
  refresh(params: ICellRendererParams) {
    this.params = params;

    return true;
  }

  async openAssignGroup() {
    alert('Assign Group feature is under development.');
  }

  updateStatus(status: string) {
    try {
      const routeRateIds: number[] = this.params.data.route_rate_ids || [];
      const rates = [{ route_rate_ids: routeRateIds, updates: { status } }];
      this.rateMangerService.updateRateStatus(rates).subscribe({
        next: (response: any) => {
          AlertUtil.success(response.message || 'Rate has been updated successfully.', 'Success!');

          let displayStatus = status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
          if (status === 'deactivated' || status === 'inactive') displayStatus = 'Deactivated';
          if (status === 'active' || status === 'published') displayStatus = 'Live';
          if (status === 'draft') displayStatus = 'Draft';
          if (status === 'in_review') displayStatus = 'In Review';

          const updatedData = { ...this.params.data, status: displayStatus };
          this.params.node.setData(updatedData);
          this.params.api.flashCells({ rowNodes: [this.params.node] });
        },
        error: (error: any) => {
          AlertUtil.error('Failed to update the status.');
        }
      });

    } catch (err: any) {
      AlertUtil.error('Failed to update the status.');
    }
  }

  async deleteRate() {
    const result = await AlertUtil.confirm(
      'Delete Rate',
      'Are you sure you want to delete this rate?',
      'Yes, delete it.'
    );

    if (result.isConfirmed) {
      const routeRateIds: number[] = this.params.data.route_rate_ids || [];
      this.rateMangerService.deleteRate(routeRateIds).subscribe({
        next: (response: any) => {
          AlertUtil.success(response.message || 'Rate has been deleted successfully.', 'Deleted!');

          this.params.api.refreshServerSide({ purge: true });
        },
        error: (error: any) => {
          AlertUtil.error('Failed to delete the rate.');
        }
      });
    }
  }
}
